var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2734 4L3.27344 14V20.6667L9.9401 24L3.27344 27.3333V34L23.2734 44L43.2734 34V27.3333L36.6068 24L43.2734 20.6667V14L23.2734 4ZM34.7434 24.9317L23.2734 30.6667L11.8035 24.9317L7.00022 27.3333L23.2734 35.4699L39.5467 27.3333L34.7434 24.9317ZM23.2734 5.86339L7.00022 14L23.2734 22.1366L39.5467 14L23.2734 5.86339Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseIcon);
export default __webpack_public_path__ + "static/media/database_icon.df6b2f1dde3189a3d72bdb4a98429d0a.svg";
export { ForwardRef as ReactComponent };